export interface ExportSettings {
  formats: {
    copyLink: boolean;
    copyMarkdown: boolean;
    downloadPdf: boolean;
  };
  sections: {
    date: boolean;
    metadata: boolean;
    description: boolean;
    agendaItems: boolean;
    animals: boolean;
    interactions: boolean;
    notes: boolean;
  };
}

export const DEFAULT_EXPORT_SETTINGS: ExportSettings = {
  formats: { copyLink: true, copyMarkdown: true, downloadPdf: true },
  sections: { date: true, metadata: true, description: true, agendaItems: true, animals: true, interactions: true, notes: true },
};
